import React from 'react';
import PropTypes from 'prop-types';

import SrText from 'client/components/SrText';
import SrSimpleMessageModal, {
  SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP,
} from 'client/components/SrSimpleMessageModal/SrSimpleMessageModal';
import { BUTTON_THEME_GREEN_ADOBE } from 'client/components/ButtonDeprecated';

import './SrBrowseBestListingsModal.less';

const SrBrowseBestListingsModal = ({ headline, onClose }) => (
  <SrSimpleMessageModal
    theme={SR_SIMPLE_MESSAGE_MODAL_THEME_SLIDE_UP}
    iconUrl="/images/houses.png"
    headline={headline}
    underline
    message={
      <SrText
        font="greycliff"
        weight="bold"
        color="grey"
        display="block"
        align="center"
        paddingRight="12px"
        paddingLeft="12px"
        lineHeight="25px"
      >
        Browse the best listings in your area and find your new home!
      </SrText>
    }
    buttonText="Browse the Best Rentals"
    buttonTheme={BUTTON_THEME_GREEN_ADOBE}
    maxWidth={375}
    maxIconWidth={295}
    maxIconHeight={292}
    onClose={onClose}
    onButtonClick={onClose}
  />
);

SrBrowseBestListingsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  headline: PropTypes.string,
};

SrBrowseBestListingsModal.defaultProps = {
  headline: 'Finding the perfect home isn’t easy, but we’ve got you covered!',
};

SrBrowseBestListingsModal.displayName = 'SrBrowseBestListingsModal';

export default SrBrowseBestListingsModal;
